import { useState, useRef } from "react";
import axios from "axios";
import dayjs from "dayjs";

import { Button } from "@mantine/core";
import { DatePicker, DateInput } from "@mantine/dates";

import Chart_Bar_CafePOS_3_1_1 from "../Chart/Chart_Bar_CafePOS_3_1_1";
import Chart_Canvas_Heatmap_3_1_1 from "../Chart/Chart_Canvas_Heatmap_3_1_1";
// import Chart_Bar_CafePOS_HeatMap_Daily from "../Chart/Chart_Bar_CafePOS_HeatMap_Daily";

const { REACT_APP_ECLIPSE_API, REACT_APP_ECLIPSE_API_LOCAL } = process.env;

const Comp_Cafe_POS_3_1_1 = ({ selectedPresentationCafe }) => {
  const [DB_CafePCList, setDB_CafePCList] = useState([]);
  const DB_CafePCList_Ref = useRef([]);
  const [pcListWithData, setPcListWithData] = useState([]); // Collected data for canvas
  const [useCanvasMode, setUseCanvasMode] = useState(false); // Toggle between modes

  const get_DB_CafePCList_ByCafe = async (cafe) => {
    setLoadTask1(0);
    console.log("load task 1 start");

    await axios
      //REACT_APP_ECLIPSE_API
      .post(`${REACT_APP_ECLIPSE_API}/get_eclipse_pos_cafepc_customlist`, {
        cafe,
      })
      .then((res) => {
        console.log("get_eclipse_pos_cafepc_customlist", res?.data);

        setDB_CafePCList(res?.data);
        DB_CafePCList_Ref.current = res?.data;
        setLoadTask1(1);
        // console.log("load task 1 done");
      });
  };

  // Batch collect all PC data for canvas rendering
  const collectAllPCData = async (date, cafe) => {
    setLoadTask1(0);
    console.log("Batch loading all PC data for canvas...", { date, cafe });

    try {
      // First load PC list if not already loaded
      let pcList = DB_CafePCList_Ref.current;
      if (pcList.length === 0) {
        const pcListResponse = await axios.post(
          `${REACT_APP_ECLIPSE_API}/get_eclipse_pos_cafepc_customlist`,
          { cafe }
        );
        pcList = pcListResponse?.data || [];
        setDB_CafePCList(pcList);
        console.log(`pcList`, pcList);
      }

      // Make all API calls in parallel
      const promises = pcList.map((pc) =>
        axios.post(
          `${REACT_APP_ECLIPSE_API}/get_awesome_pos__pcdata_hourly_in_a_day__bydate_cafe_pc`,
          {
            date_1day: date,
            cafe: cafe,
            pc: pc.zjm,
          }
        )
      );

      const results = await Promise.all(promises);
      console.log(`results`, results);

      // Format data for canvas component
      const formattedData = pcList.map((pc, index) => ({
        pc: pc.zjm,
        zone: `${pc.pczone_name} (${pc.dlip})`,
        remark: pc.pc_name_remark_n,
        data: results[index]?.data || [],
      }));
      console.log(`formattedData`, formattedData);

      setPcListWithData(formattedData);
      setLoadTask1(1);
      setUseCanvasMode(true);
      console.log("All PC data loaded for canvas");
    } catch (error) {
      console.error("Error loading PC data:", error);
      setLoadTask1(1);
    }
  };

  //----------------------------------- global variable

  const [load_1, setLoad_1] = useState(true);
  const [load_2, setLoad_2] = useState(false);
  const [load_3, setLoad_3] = useState(false);
  const [load_4, setLoad_4] = useState(false);
  const [load_5, setLoad_5] = useState(false);

  const [loadTask1, setLoadTask1] = useState(1);

  const [selectedPresentationOption, setSelectedPresentationOption] =
    useState("selected_cafe");
  // const [selectedPresentationCafe, setSelectedPresentationCafe] = useState("");

  const [selectedPresentationMode, setSelectedPresentationMode] = useState("");
  const [calenderValue, setCalenderValue] = useState(new Date()); //
  const [selectedDay, setSelectedDay] = useState(
    dayjs(new Date()).format("YYYY-MM-DD")
  );

  //----------------------------------- func

  const Custom_Margin = (_time) => {
    let result = null;
    if (_time == "06:00" || _time == "12:00" || _time == "18:00") {
      result = "0.5rem";
    } else {
      result = "0.1rem";
    }

    return result;
  };

  // Generate time blocks every 15 minutes
  const timeBlocks = [];
  const startTime = dayjs(`${selectedDay} 00:00`);
  for (let i = 0; i < 96; i++) {
    const time = startTime.add(i * 15, "minute");
    timeBlocks.push(time);
  }

  const COMP_ShowAllTimesTag = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",

            // backgroundColor: stringToColor(pczoneSelected),
            gap: 10,
            border: "2px solid transparent",
          }}
        >
          <div
            style={{
              width: "120px",
              minWidth: "120px",
              fontSize: 10,
              display: "flex",
              flexDirection: "row",
              flexWrap: "nowrap",
              marginLeft: 10,
            }}
          >
            <div> </div>
          </div>
          <div
            style={{
              width: "80px",
              minWidth: "80px",
              fontSize: 15,
              textAlign: "right",
            }}
          >
            <div> </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: 0,
              width: "1400px",
              minWidth: "1400px",
            }}
          >
            {/* {[1, 2]?.map((x) => {
              return (
                <div
                  style={{
                    marginLeft: "0.1rem",
                    marginBottom: "0.1rem",
                    backgroundColor: "white",
                    color: "black",
                    width: "30px",
                  }}
                >
                  <div>{x}</div>
                </div>
              );
            })} */}
            {timeBlocks?.map((time, idx) => {
              return (
                <div
                  key={idx}
                  style={{
                    width: 13, // narrower, since height will be more
                    height: 38, // taller to accommodate rotated text
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#eee",
                    color: "black",
                    borderRadius: 0,
                    fontSize: 10,
                    writingMode: "vertical-rl",
                    transform: "rotate(180deg)",
                    whiteSpace: "nowrap",
                    marginBottom: "0.1rem",
                    // marginLeft: "-0.1rem",
                    // marginRight: "-0.1rem",
                    marginLeft: Custom_Margin(time.format("HH:mm")),
                  }}
                >
                  {time.format("HH:mm")}
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  };

  function forwardOneDay() {
    setCalenderValue((prev) => dayjs(prev).add(1, "day").toDate());
    setSelectedDay((prev) => dayjs(prev).add(1, "day").format("YYYY-MM-DD"));
  }

  function backOneDay() {
    setCalenderValue((prev) => dayjs(prev).subtract(1, "day").toDate());
    setSelectedDay((prev) =>
      dayjs(prev).subtract(1, "day").format("YYYY-MM-DD")
    );
  }

  // useEffect(() => {
  //   get_DB_CafePCList_ByCafe(selectedPresentationCafe);
  //   setLoad_2(false);
  //   setLoad_3(false);
  //   setLoad_4(false);
  //   setLoad_5(false);
  // }, [selectedPresentationCafe]);

  return (
    <div>
      <div>3.1. Group By PC (measure by time)</div>
      <h2>3.1.1. Hourly </h2>
      <div
        style={{
          backgroundColor: "white",
          padding: "1rem",
          borderRadius: "1rem",
          position: "sticky",
          top: 50,
          zIndex: 999,
        }}
      >
        <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          <Button disabled={loadTask1 == 0} color="dark" onClick={backOneDay}>
            Previous Day
          </Button>
          <Button
            disabled={loadTask1 == 0}
            color="dark"
            onClick={forwardOneDay}
          >
            Next Day
          </Button>
          <div style={{ color: "black" }}>
            <b>Picked Day :</b>
            <br />
            <b>{dayjs(calenderValue).format("YYYY-MM-DD ddd")}</b>
          </div>
          <div>
            <DateInput
              clearable={false}
              disabled={loadTask1 == 0}
              value={calenderValue}
              onChange={(e) => {
                setSelectedDay(dayjs(e).format("YYYY-MM-DD"));
                return setCalenderValue(e);
              }}
            />
          </div>
          <Button
            color="green"
            disabled={loadTask1 == 0}
            onClick={() => {
              get_DB_CafePCList_ByCafe(selectedPresentationCafe);
              setUseCanvasMode(false);
              setLoad_2(false);
              setLoad_3(false);
              setLoad_4(false);
              setLoad_5(false);
            }}
          >
            Check (classic)
          </Button>
          <Button
            color="lime"
            disabled={loadTask1 == 0}
            onClick={() => {
              collectAllPCData(selectedDay, selectedPresentationCafe);
            }}
          >
            Check (new)
          </Button>
          {/* <div
                          style={{ color: "black" }}
                        >{`selectedDay:${selectedDay}`}</div> */}
          <div style={{ color: "black" }}>
            {`Total PCs : ${DB_CafePCList?.length}, `}
          </div>
          <div style={{ color: "black" }}>
            {loadTask1 == 0 ? (
              <div style={{ color: "orange" }}>Loading...</div>
            ) : (
              <div style={{ color: "green" }}>
                {`Data Loaded = ${loadTask1 * 100}%`}
              </div>
            )}
          </div>
        </div>
      </div>
      <br />
      <br />

      {!useCanvasMode && <COMP_ShowAllTimesTag />}

      {useCanvasMode ? (
        // Canvas Mode - High Performance
        <div style={{ marginTop: "2rem" }}>
          <h3 style={{ color: "green" }}>🚀 Canvas Mode - All view</h3>
          <Chart_Canvas_Heatmap_3_1_1
            dateSelected={selectedDay}
            pcListData={pcListWithData}
          />
        </div>
      ) : (
        // Old Mode - Individual components
        DB_CafePCList?.map((x, i) => {
          return (
            <Chart_Bar_CafePOS_3_1_1
              key={i}
              // icon={<IconCalendar size={16} />}
              dateSelected={selectedDay}
              cafeSelected={selectedPresentationCafe}
              pcSelected={x?.zjm}
              pcRemarkSelected={x?.pc_name_remark_n}
              pczoneSelected={`${x?.pczone_name} (${x?.dlip})`}
            />
          );
        })
      )}
    </div>
  );
};

export default Comp_Cafe_POS_3_1_1;
